import { __assign, __rest } from "tslib";
import * as React from 'react';
import { Spinner } from 'wix-ui-tpa';
/**
 * SpinnerWrapper component
 * This component is meant ot fix the intermittent problem we have with wix-ui-tpa `<Spinner>`.
 * Sometimes the animation style of the spinner's outer container (the `<svg>` element) is applied to the inner element
 * (the `<circle>` element), which causes the spinner to spin outside its center instead of spinning around its center.
 * This component forces the inner `<circle>` element to have the correct animation style (as it is defined in https://github.com/wix-private/wix-design-systems/blob/master/packages/wix-ui-tpa/src/components/Spinner/Spinner.st.css).
 * It uses inline `<style>` tag to avoid corruption that might happen by WebPack minification. (with a trick taken from https://stackoverflow.com/a/34200213/46635)
 *
 * JIRA: https://jira.wixpress.com/browse/SCHED-33030
 * Slack: https://wix.slack.com/archives/CJRU3U97A/p1699431330439009
 */
var css = "\n.spinnerWrapper circle {\n  animation: spinnerWrapperFrames 1.5s ease-in-out infinite !important;\n}\n\n@keyframes spinnerWrapperFrames {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n";
export var SpinnerWrapper = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(React.Fragment, null,
        React.createElement("style", null, css),
        React.createElement(Spinner, __assign({ className: "spinnerWrapper ".concat(className) }, props))));
};
//# sourceMappingURL=SpinnerWrapper.js.map